module.exports = __webpack_public_path__ + "img/facts-all_2013.82381364.png";